<script lang="ts">
  export let style: string = "";
</script>

<div style={'position: relative;' + style}>
  <slot />
</div>
